import React from 'react';
import { motion } from 'framer-motion';
import { Sun, CheckCircle, Leaf, Zap } from 'lucide-react';

const AboutPage = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow pt-24 bg-background">
        <div className="container-solar py-12 md:py-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Empowering India with <span className="solar-text-gradient">Solar Energy</span>
            </h1>
            <p className="text-lg text-muted-foreground">
              At SolarSavers, our mission is to make solar energy accessible, affordable, and transparent
              for every household and business. We connect you with top-tier vendors and seamless financing options.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
            {[
              { icon: Leaf, title: 'Sustainable Future', desc: 'Promoting green energy to reduce carbon footprints and build a sustainable world.' },
              { icon: CheckCircle, title: 'Trusted Quality', desc: 'Partnering only with certified vendors offering top-of-the-line panels and inverters.' },
              { icon: Zap, title: 'Smart Connectivity', desc: 'End-to-end marketplace experience handling products, installation, and subsidies.' },
            ].map((feature, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                className="bg-card p-8 rounded-2xl border border-border shadow-sm hover:shadow-md transition-shadow text-center"
              >
                <div className="w-16 h-16 mx-auto mb-6 bg-primary/10 rounded-full flex items-center justify-center">
                  <feature.icon className="w-8 h-8 text-primary" />
                </div>
                <h3 className="text-xl font-bold mb-4">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.desc}</p>
              </motion.div>
            ))}
          </div>

          <div className="bg-secondary/30 rounded-3xl p-8 md:p-12 mb-10 overflow-hidden relative">
            <div className="absolute top-0 right-0 p-8 opacity-5">
              <Sun className="w-64 h-64" />
            </div>
            <div className="relative z-10 max-w-2xl">
              <h2 className="text-3xl font-bold mb-6">Our Story</h2>
              <div className="space-y-4 text-muted-foreground">
                <p>
                  Founded with a vision to democratize renewable energy, SolarSavers started as a small initiative
                  to guide homeowners through the complex process of going solar. Today, we are a leading multi-vendor
                  marketplace.
                </p>
                <p>
                  We believe that the transition to clean energy shouldn't be complicated. By bringing together
                  the best installers, competitive prices, and government subsidy knowledge onto a single platform,
                  we ensure you save both the planet and your wallet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AboutPage;
